import { CurrencyPipe } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, RouteReuseStrategy, withHashLocation } from "@angular/router";
import { provideServiceWorker } from "@angular/service-worker";
import { APP_ROUTES, AppRouteReuseStrategy } from "@app/app-routing.module";
import { I18nModule } from "@app/i18n.module";
import { INDEXED_DB_CONFIG } from "@app/indexed-db-config";
import { ProductFruitsConfigService } from "@app/product-fruits-config.service";
import { ResilientIndexedDbService } from "@app/resilient-indexed-db.service";
import { TokenInterceptor } from "@app/token.interceptor";
import { environment } from "@environments/environment";
import { provideTheming, Theme } from "@odx/angular/theming";
import { provideProductFruits } from "@odx/product-fruits";
import * as Sentry from "@sentry/angular";
import { OAuthModule, OAuthStorage } from "angular-oauth2-oidc";
import { NgxIndexedDBModule, NgxIndexedDBService } from "ngx-indexed-db";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(APP_ROUTES, withHashLocation()),
    { provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy },
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    provideTheming({
      autoDetect: false,
      defaultTheme: Theme.LIGHT,
    }),
    provideServiceWorker("ngsw-worker.js", {
      enabled: environment.production,
      registrationStrategy: "registerWhenStable:30000",
    }),
    importProvidersFrom(NgxIndexedDBModule.forRoot(INDEXED_DB_CONFIG)),
    { provide: NgxIndexedDBService, useClass: ResilientIndexedDbService },
    I18nModule.setLocale(),
    I18nModule.setLocaleId(),
    CurrencyPipe,
    {
      provide: Sentry.TraceService,
      deps: [],
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({}),
    },
    importProvidersFrom(
      OAuthModule.forRoot({
        resourceServer: {
          allowedUrls: [environment.dataBackendUrl, environment.apiUrl],
          sendAccessToken: true,
        },
      }),
    ),
    { provide: OAuthStorage, useFactory: () => localStorage },
    provideProductFruits(
      () => {
        const configService = inject(ProductFruitsConfigService);
        return configService.config$;
      },
      { disabled: !environment.production },
    ),
  ],
};
